import { useNavigate } from "react-router-dom";
import { useIsAdmin } from "@/hooks/useIsAdmin";
import { useAuth } from "./AuthProvider";
import LoadingSpinner from "../ui/LoadingSpinner";
import { Button } from "../ui/button";

const AdminRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAdmin, isLoading: isAdminLoading } = useIsAdmin();
  const { loading: authLoading } = useAuth();
  const navigate = useNavigate();

  // Show loading spinner while either auth or admin status is being checked
  if (authLoading || isAdminLoading) {
    return <LoadingSpinner />;
  }

  // Only redirect if we're sure the user is not an admin
  if (!isAdmin) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-background">
        <h2 className="text-3xl font-semibold text-destructive mb-4">
          Access Denied
        </h2>
        <p className="text-base text-muted-foreground">
          You must be an admin to view this page.
        </p>
        <Button
          onClick={() => navigate("/")}
          className="mt-4"
        >
          Back to Home
        </Button>
      </div>
    );
  }

  return <>{children}</>;
};

export default AdminRoute;